import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation resources
import translationEN from './locales/en/translation.json';

const resources = {
  en: {
    translation: translationEN
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false // react already does escaping
    }
  });

export default i18n;